import * as d3 from 'd3'
export default {
  methods: {

    draw_PieChart() {

      this.get_CoordinatorsXY(this.circle.cx, this.circle.cy, -this.guide.in, 'inX', 'inY')
      this.get_CoordinatorsXY(this.circle.cx, this.circle.cy, this.guide.out, 'outX', 'outY')
      this.get_PieChartData()

      this.canvasForms // Shadow
      .append('ellipse')
      .attr('cx', this.circle.cx).attr('cy', this.circle.cy + this.circle.dia)
      .attr('rx', this.circle.dia).attr('ry', this.circle.dia * 0.1)
      .attr('fill', `url(#SHADOW_${this.localId})`)

      var arc = d3.arc()
      .outerRadius(d => d.data.stack)
      .innerRadius(this.circle.hole)
      .cornerRadius(this.circle.radius) // Coner Radius

      var pie = d3.pie()
      .sort(null)
      .value((d) => d.value)
      .padAngle(this.circle.slice/100) // Padding Pie

      let donutGroup = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)
      
      pie(this.pieSectors).forEach((d, i) => {
        donutGroup
        .append('path')
        .attr('id', `PIE_${i}_${this.localId}`)
        .attr('fill', (this.colorSet[i].color.substr(0,1) == '#') ? this.colorSet[i].color : `url(#${this.localId}_${this.colorSet[i].color}_)`)
        .attr('opacity', this.colorSet[i].opacity)
        // .call(this.event_Link, this.colorSet[i], i)
        .transition().duration(this.circle.duration ? this.circle.duration : 500)
        .attrTween('d', () => {
          var interpolate = d3.interpolate({startAngle: 0, endAngle: 0}, d)
          return function(t) { return arc(interpolate(t)) }
        })
        
      })
    },


    get_CoordinatorsXY(Cx, Cy, size, nameX, nameY) {

      this.rawData.forEach((d,i) => {

        let ra = d.stack + size
        let a = 360 * d.angle
        let aCalc = a > 180 ? 360 - a : a
        let aRad = (aCalc * Math.PI) / 180
        let z = Math.sqrt(2 * ra * ra - 2 * ra * ra * Math.cos(aRad))
        let x = aCalc <= 90 ? ra * Math.sin(aRad) : ra * Math.sin(((180 - aCalc) * Math.PI) / 180)
        let endY = Math.sqrt(z * z - x * x)
        let endX = a <= 180 ? ra + x : ra - x

        this.pieSectors[i] = {
          ...this.pieSectors[i],
          ...{
            [nameX]: endX + Cx - ra,
            [nameY]: endY + Cy - ra,
          }
        }
      })
    },


    get_PieChartData() {
      var ra
      var a = 0 // Angle
      var aCalc = 0 //
      var arcSweep = 0
      var aRad = 0 // Angle in Rad
      var z = 0 // Size z
      var x = 0 // Side x
      var endX = 0 // SVG endX coordinate
      var endY = 0 // SVG endY coordinate
      var Ro = 0 // Rotation

      var h_ra
      var h_z = 0 // Size z
      var h_x = 0 // Side x
      var h_endX = 0 // SVG endX coordinate
      var h_endY = 0 // SVG endY coordinate

      var textSpace = 0
      var direct = 0
      var align = 0

      this.rawData.forEach((d,i) => {
        ra = d.stack
        h_ra = this.circle.hole // Hole
        a = 360 * (d.VALUE / 100)
        aCalc = a > 180 ? 360 - a : a
        aRad = (aCalc * Math.PI) / 180
        z = Math.sqrt(2 * ra * ra - 2 * ra * ra * Math.cos(aRad))
        h_z = Math.sqrt(2 * h_ra * h_ra - 2 * h_ra * h_ra * Math.cos(aRad)) // Hole
        if (aCalc <= 90) {
          x = ra * Math.sin(aRad)
          h_x = h_ra * Math.sin(aRad) // Hole
        } else {
          x = ra * Math.sin(((180 - aCalc) * Math.PI) / 180)
          h_x = h_ra * Math.sin(((180 - aCalc) * Math.PI) / 180)
        }

        endY = Math.sqrt(z * z - x * x)
        h_endY = Math.sqrt(h_z * h_z - h_x * h_x) // Hole

        if (a <= 180) {
          endX = ra + x
          h_endX = h_ra + h_x
          arcSweep = 0
        } else {
          endX = ra - x
          h_endX = h_ra - h_x
          arcSweep = 1
        }
        if (d.angle < 0.5) {
          direct = this.guide.extend
          align = 'start'
          textSpace = 5
        } else {
          direct = -this.guide.extend
          align = 'end'
          textSpace = -5
        }

        this.pieSectors[i] = {
          ...this.pieSectors[i],
          ...{
            angle: a,
            value: d.VALUE,
            title: d.NAME,
            // color: this.circle.colors[i],
            arcSweep: arcSweep,
            Ra: ra,
            endX: endX,
            endY: endY,

            h_Ra: h_ra, // Hole
            h_endX: h_endX, // Hole
            h_endY: h_endY, // Hole
            Ro: Ro,
            direct: direct,
            align: align,
            textSpace: textSpace,
            stack: d.stack
          }
        }

        Ro = Ro + a
      })
    },
    


  }
}
